export const SET_THEME = 'SET_THEME';

export const setThemeWeb = theme => ({
    type: SET_THEME,
    payload: {
        theme
    }
});
